import { BranchViewModel } from '@app/shared/models/branch-view.model';

export class DeliveryViewModel {
  public isNew: boolean;

  constructor(
    public id: number,
    public name: string,
    public username: string,
    public branch: BranchViewModel,
    public branchID: number,
    public imageName: string,
    public active: boolean,
    public canDeliverOrders: boolean,
    public phone: string,
    public userHQ: string,
    public ratingOrderDelivery?: number,
  ) { }
}
